<template>
	<div class="sidebar-wrapper" :class="{ 'active' : sidebarActive }">
		<div class="sidebar">

			<div class="inner">
				<template v-if="sidebarActive">
					<ObjectEditSidebar v-if="type === 'objectedit'" :data="data" ref="objectedit"></ObjectEditSidebar>
					<PrivilegesSidebar v-if="type === 'privileges'" :data="data" ref="privileges"></PrivilegesSidebar>
					<TranslationsSidebar v-if="type === 'translations'" :data="data" ref="translations"></TranslationsSidebar>
					<SubmissionSidebar v-if="type === 'submission'" :data="data" ref="submission"></SubmissionSidebar>
				</template>
			</div>

			<div class="btns-top">
				<a class="btn btn-submit transition-fadeinup fa fa-save" v-on:click="saveFormClickHandler"></a>
				<a v-if="type === 'translations' && permissions.add" href="#" class="btn btn-add fa fa-plus transition-fadeinup transition-delay-01" @click="addItemClickHandler"></a>
			</div>

			<div class="marker"></div>

		</div>
		<div class="overlay" v-on:click="toggle"></div>
	</div>
</template>

<script>

import general from '../../modules/general.js'

export default {
	name: 'basesidebar',
	props: {
		type: String,
		data: Object
	},

	components: {
		ObjectEditSidebar: () => import('./ObjectEditSidebar.vue'),
		PrivilegesSidebar: () => import('./PrivilegesSidebar.vue'),
		TranslationsSidebar: () => import('./TranslationsSidebar.vue'),
		SubmissionSidebar: () => import('./SubmissionSidebar.vue')
	},

	computed: {
		marketOffsetTop: {
			get: function () {
				var val = null
				if (this.data) {
					if (this.data.marketOffsetTop) {
						val = this.data.marketOffsetTop
					}
				}
				return val
			},
			set: function () {

			}
		},

		entity: {
			get: function () {
				var val = null
				if (this.data) {
					if (this.data.entity) {
						val = this.data.entity
					}
				}
				return val
			},
			set: function () {

			}
		}
	},

	watch: {
		marketOffsetTop: function (newVal, oldVal) {
			// marker position
			var marker = this.$el.querySelector('.marker')
			marker.classList.remove('hidden')
			marker.style.top = newVal + 'px'
		},

		entity: function (newVal, oldVal) {
			this.permissions = general.checkPermissions(newVal.privileges, this.user.roles)
		}
	},

	data () {
		return {
			sidebarActive: false,
			roles: this.$store.state.user.roles,
			user: this.$store.state.user,
			permissions: {
				add: false,
				edit: false,
				delete: false
			}
		}
	},

	mounted () {
		this.body = document.querySelector('body')
		this.marker = this.$el.querySelector('.marker')
	},

	methods: {
		toggle (target) {
			if (!this.sidebarActive) {
				this.sidebarActive = true
				this.body.classList.add('sidebar-active')

				// hide marker when there is no position given
				var marker = this.$el.querySelector('.marker')
				var markerVisible = target.getAttribute('data-marker')
				if (markerVisible === 'false') {
					marker.classList.add('hidden')
				} else {
					marker.classList.remove('hidden')
				}
			} else {
				this.sidebarActive = false
				this.body.classList.remove('sidebar-active')
			}

			this.$forceUpdate()
		},

		saveFormClickHandler (e) {
			e.preventDefault()

			this.$refs[this.type].save()
		},

		addItemClickHandler (e) {
			e.preventDefault()

			this.$refs[this.type].addItem()
		}
	}
}

</script>
